import { useContext } from "react";
import { BrowserRouter, Routes, Route, Navigate, Link } from "react-router-dom";
import { UserContext } from "../context/User.context";
import {
  Login,
  Main,
  Home,
  DashboardUser,
  JobDashboardList,
  ProfileUser,
  ChangePassword,
  ProfileEdit,
  // DetailUmkm,
} from "../layout/index";
// import {
//   FormVisitor,
//   ViewVisitor,
//   VisitorComponent,
//   DetailVisior,
//   SearchDetailVisitor,
// } from "../layout/guest/index";

import {
  // GridCard,
  // DetailCard,
  // StatisticsVisitor,
  JobForm,
} from "../layout/admin/index";
// import UmkmGrid from "../layout/guest/umkm/TableGuest";
import AboutPage from "../layout/landingpage/about/About";
import EventPage from "../layout/guest/event/eventpage";
import ArticleDetail from "../layout/guest/event/DetailEvenet";
import CareerPage from "../layout/guest/career/CareerPage";
import CareerDetail from "../layout/guest/career/DetailCareer";
import IntershipPage from "../layout/guest/career/intership/IntershipPage";
import IntershipDetail from "../layout/guest/career/intership/IntershipCareer";
import { DetailJob } from "../layout/admin/job/DetailJob";
import { EventTable } from "../layout/admin/event/Table";
import { EventFormPage } from "../layout/admin/event/Form";
import { DetailEvent } from "../layout/admin/event/DetailEvent";
import { JobEditForm } from "../layout/admin/job/EditForm";

const MainRouter = () => {
  const { user } = useContext(UserContext);
  const PrivateRoute = ({ children }) => {
    // Handle Back To Login
    if (user) {
      return children;
    } else {
      return <Navigate to="/login" replace={true} />;
    }
  };

  const LoginRoute = ({ children }) => {
    if (user) {
      return <Navigate to="/user" replace={true} />;
    } else {
      return children;
    }
  };
  return (
    <>
      <BrowserRouter>
        <Routes>
          {/* GUEST */}
          <Route path="/about" element={<AboutPage />} />
          <Route path="/event" element={<EventPage />} />
          <Route path="/event/:id" element={<ArticleDetail />} />
          <Route path="/career" element={<CareerPage />} />
          <Route path="/career/:id" element={<CareerDetail />} />
          <Route path="/career/intership" element={<IntershipPage />} />
          <Route path="/career/intership/:id" element={<IntershipDetail />} />

          {/* Auth */}
          <Route
            path="/login"
            element={
              <LoginRoute>
                <Login />
              </LoginRoute>
            }
          />

          {/* <Route
            path="/register"
            element={
              <LoginRoute>
                <Register />
              </LoginRoute>
            }
          /> */}

          <Route path="/" element={<Main />}>
            <Route index element={<Home />} />
          </Route>

          <Route path="/user" element={<DashboardUser />}>
            <Route
              index
              element={
                <PrivateRoute>
                  <JobDashboardList />
                </PrivateRoute>
              }
            />
            <Route path="editevent/:code" element={<EventFormPage />} />
            <Route path="addevent" element={<EventFormPage />} />
            <Route path="event-admin" element={<EventTable />} />
            <Route path="detail-event/:code" element={<DetailEvent />} />
            <Route
              path="addjob"
              element={
                <PrivateRoute>
                  <JobForm />
                </PrivateRoute>
              }
            />
            <Route
              path="job-edit/:code"
              element={
                <PrivateRoute>
                  <JobEditForm />
                </PrivateRoute>
              }
            />

            <Route
              path="profile"
              element={
                <PrivateRoute>
                  <ProfileUser />
                </PrivateRoute>
              }
            />
            <Route
              path="detail-job/:code"
              element={
                <PrivateRoute>
                  <DetailJob />
                </PrivateRoute>
              }
            />

            <Route
              path="change-pwd"
              element={
                <PrivateRoute>
                  <ChangePassword />
                </PrivateRoute>
              }
            />

            <Route
              path="profile-edit"
              element={
                <PrivateRoute>
                  <ProfileEdit />
                </PrivateRoute>
              }
            />
          </Route>

          <Route path="*" element={<NoMatchPage />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

function NoMatchPage() {
  return (
    <div>
      <h2>Nothing to see here!</h2>
      <p>
        <Link to="/">Back to login</Link>
      </p>
    </div>
  );
}

export default MainRouter;
